<template>
    <section class="gradient-custom">
        <div class="container my-5 py-5">
            <img v-bind:src="require('@/assets/logo_dark.png')" alt="Responsive image" style="width: 200px;">
            <div class="row d-flex justify-content-center py-5">
                <div class="col-md-7 col-lg-5 col-xl-8">
                    <div class="card" style="border-radius: 15px;">
                        <div class="card-body">
                            <h5 class="card-title">You have an active subscription</h5>
                            <p id="typeName" class="form-control form-control-lg" siez="17" aria-label="Default"
                                aria-describedby="inputGroup-sizing-default">{{ userP }}</p>
                            <br>
                            <h5 class="card-title">Your subscription expires on</h5>
                            <p id="typeName" class="form-control form-control-lg" siez="17" aria-label="Default"
                                aria-describedby="inputGroup-sizing-default">{{ date }}</p>
                            <br>
                            <p align="left">*Only applies to Android and iOS users see <a
                                    href="https://napoleon.chat/terminos-condiciones" style="color:#d7a952;"
                                    target="_blank">terms and conditions</a></p>
                            <a href="https://napoleon.chat/" type="button"
                                class="btn btn-outline-dark">Exit</a>&nbsp;&nbsp;
                            <button type="button" class="btn btn-outline-warning" v-on:click="search">Search Nickname</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import store from '@/store';
import { ConvertDates } from '@/Utlis/ConvertDates';
import { mapState } from 'vuex';

export default {
    name: 'SubscribedComponent',
    data() {
        return {
            userP: "",
            date: "",
        }
    },
    computed: mapState(['user', 'expired']),
    mounted() {
        this.consultUser()
    },
    methods: {
        async consultUser() {
            if (this.user.id == 0) {
                this.$router.push({ name: 'search' })
                return
            }
            this.userP = this.user.nick
            this.getPayment()
        },
        async getPayment() {
            this.date = ConvertDates().dateComparison(this.expired)
            store.commit('setLoad', false)
        },
        search() {
            this.$router.push({ name: 'search' })
        },
    },
}
</script>